export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [
            {
              label: '18-34',
              value: 1,
              selected: false
            },
            {
              label: '35-49',
              value: 2,
              selected: false
            },
            {
              label: '50-64',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Gender',
          code: 'gender',
          multi: true,
          options: [
            {
              label: 'Male',
              value: 1,
              selected: false
            },
            {
              label: 'Female',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },

        {
          label: 'Children <18 in HH',
          // excludeFromVerbatims: true,
          code: 'children',
          multi: true,
          options: [
            {
              label: 'Has Children in HH',
              value: 1,
              selected: false
            },
            {
              label: 'No Children in HH',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Disney+ Users',
          code: 'disney_plus',
          multi: true,
          options: [
            {
              label: 'Customer',
              value: 1,
              selected: false
            },
            {
              label: 'Non-Customer',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Hulu Users',
          code: 'hulu',
          multi: true,
          options: [
            {
              label: 'Customer',
              value: 1,
              selected: false
            },
            {
              label: 'Non-Customer',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'HBO Max Users',
          code: 'max',
          multi: true,
          options: [
            {
              label: 'Customer',
              value: 1,
              selected: false
            },
            {
              label: 'Non-Customer',
              value: 2,
              selected: false
            }
          ]
        },
      ]
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/components/scorecard/ScorecardView/ScorecardFilter/index.js